import { Spin } from 'antd';
import React, { Suspense } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import myProfile from '../../container/myProfileManagement/myProfile';
import withAdminLayout from '../../layout/withAdminLayout';
import prospectsManagement from '../seller/prospectsManagement';
import cataloguesManagement from './cataloguesManagement';
import Dashboard from './dashboardBalken';
import paymentsManagement from './paymentsManagement';
import projectManagement from './projectManagement';
import statesManagement from './stateManagement';
import ticketManagement from './ticketsManagement';
import UserManagement from './userManagement';

function Admin() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route path={path} component={Dashboard} />
        <Route path={`${path}/dashboard`} component={Dashboard} />
        <Route path={`${path}/perfil`} component={myProfile} />
        <Route path={`${path}/gestion-usuarios`} component={UserManagement} />
        <Route path={`${path}/proyectos`} component={projectManagement} />
        <Route path={`${path}/inmuebles`} component={statesManagement} />
        <Route path={`${path}/catalogos`} component={cataloguesManagement} />
        <Route path={`${path}/pagos`} component={paymentsManagement} />
        <Route path={`${path}/prospectos`} component={prospectsManagement} />
        <Route path={`${path}/tickets`} component={ticketManagement} />
      </Suspense>
    </Switch>
  );
}

export default withAdminLayout(Admin);
